import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface InfoGridField {
  label: string;
  value: ReactNode;
}

interface InfoGridProps {
  fields: InfoGridField[];
  /**
   * Design-Test Stufe 2 (25.10.2026): additive Spaltenzahl. Default 3 =
   * Bestandsraster; die Fall-Ansicht nutzt 2 (Label/Wert, ruhiger).
   */
  spalten?: 2 | 3;
}

/**
 * Label/Wert-Raster. Label 12px grau darueber, Wert 14px dunkel — beide aus
 * den Theme-Rollen `label`/`wert` (Design-Test Stufe 2).
 */
const InfoGrid: FC<InfoGridProps> = ({ fields, spalten = 3 }) => (
  <Box
    sx={spalten === 2
      ? { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', columnGap: 6, rowGap: 4 }
      : { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '5px 10px' }}
  >
    {fields.map((field) => (
      <Box key={field.label}>
        <Typography variant="label">
          {field.label}
        </Typography>
        <Typography variant="wert" component="div">
          {field.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default InfoGrid;
